// extracted by mini-css-extract-plugin
export default {"head":"HabitDetail_head__ORXoH","detail":"HabitDetail_detail__doZCo","weeks":"HabitDetail_weeks__+EDyl"};